<template>
    <div class="lg:w-[620px] lg_tall:w-[560px] h-[148px] flex pl-4 bg-white rounded-xl">
        <img class="w-[78px] h-[78px] mt-3" :src="avaratUrl" alt="">
        <div class="mt-3 ml-6 flex flex-col gap-y-[10px]">
            <p class="text-main-1 text-small-size">{{ name }}</p>
            <p class="text-gray_1 text-content-size font-medium">{{ title }}</p>
            <p class="text-text-1 text-small-size lg:w-[458px] lg_tall:w-[400px]" v-html="description"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['avaratUrl', 'name', 'title', 'description'],
    data() {
        return {
        }
    }
}
</script>